
export default {
  props: ['texte']
}
